import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Text, Button, SearchBar, Loader, Theme, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';

import Header from '../../components/Header.js';
import UserCard from '../../components/Cards/UserCard.js';
import { getUsers } from '../../actions/users.js';
import permissionLevel from '../../services/permissions.js';

class UserList extends PureComponent {
    state = {
        query: ''
    };

    static getDerivedStateFromProps(props) {
        if (!permissionLevel('Members', props.accessType).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    componentDidMount() {
        if (!this.props.users) {
            this.props.dispatch(getUsers(this.state.query, 0));
        }
    }

    // submit a new search, we must reset the cursor
    _search = () => {
        this.props.dispatch(getUsers(this.state.query, 0));
    };

    _handleInputChange = (type, event) => {
        this.setState({
            [type]: event.target.value
        });
    };

    _loadMore = () => {
        this.props.dispatch(getUsers(this.state.query, false));
    };

    render() {
        if (!this.props.users) {
            return <Loader isContainer/>;
        }

        return (
            <ContainerControlSite background={"true"}>
                <Header
                    subHeader="Members"
                    selectedTitle="members"
                />

                <Content>
                    <SearchBar
                        testid="user-list-search"
                        onChange={(value) => this._handleInputChange('query', value)}
                        search={this._search}
                        placeholder="Search..."
                        iconColor={Theme.colors.skyBlue}
                        customStyle={{
                            margin: '20px auto',
                            width: '100%',
                            backgroundColor: Theme.colors.surface
                        }}
                    />

                    {
                        this.props.users.map((user) => (
                            <Link key={user.userID} to={`/members/${ user.userID }`} style={{ textDecoration: 'none' }}>
                                <UserCard testid={user.status === 1 ? 'user-list-block-active' : 'user-list-block-inactive'} user={user} />
                            </Link>
                        ))
                    }

                    {
                        this.props.users.length === 0 &&
                        <Text
                            testid="user-list-block"
                            align="center"
                            mediumLarge
                            display="block"
                        >
                            No results to display
                        </Text>
                    }

                    {
                        this.props.cursor >= 0 &&
                        <Button
                            onClick={this._loadMore}
                            color="primary"
                            marginTop={2}
                            fullWidth
                        >
                            Load More
                        </Button>
                    }
                </Content>

                <span id="users" />
            </ContainerControlSite>
        );
    }
}

UserList.propTypes = {
    users: PropTypes.array,
    cursor: PropTypes.number,
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    users: state.users.list,
    cursor: state.users.cursor,
    accessType: state.master.access
});

export default connect(mapStateToProps)(UserList);